export const GaleriaPage = () => {
  const gallery = [
    {
      id: 'gallery-hands-on-learning',
      src: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/va5qhg3u_16846208-1912-445c-b2db-e76ffcd8457b.jpeg',
      alt: 'Estudiantes participando en actividad de aprendizaje práctico'
    },
    {
      id: 'gallery-sensory',
      src: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/t7o0ztri_0ad6546f-86f7-4b43-8e8f-977c3c21a0d4.JPG',
      alt: 'Estudiante feliz con proyecto sensorial de animales'
    },
    {
      id: 'gallery-technology',
      src: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/t8uohks9_8d753b18-56ab-4c8f-9a6c-137600ab310e.jpeg',
      alt: 'Estudiantes utilizando tecnología educativa moderna'
    },
    {
      id: 'gallery-mural',
      src: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/7vm405h7_1a22a3af-b9ab-475a-9193-e27a6405e384.JPG',
      alt: 'Estudiantes pintando un mural colorido'
    },
    {
      id: 'gallery-crafts',
      src: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/2ootpy36_d1505ed5-d984-4a60-a3cb-6ba80b60fc45.JPG',
      alt: 'Grupo de estudiantes y educadores en actividad manual'
    },
    {
      id: 'gallery-educator-support',
      src: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/i85yhkse_302a1ebc-64bf-4400-bf5a-707531e7b2fa.jpeg',
      alt: 'Educadora acompañando a estudiante durante la lección'
    },
    {
      id: 'gallery-collaboration',
      src: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/lsg205ng_7f94a0b1-6a53-4805-aa42-65035a8c1b33.jpeg',
      alt: 'Estudiantes colaborando en sesión grupal'
    },
    {
      id: 'gallery-student-engagement',
      src: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/h0cjokc6_ad85918f-b7f6-4d3b-bded-a03df36cd518.jpeg',
      alt: 'Estudiante motivado durante actividad de aprendizaje'
    },
    {
      id: 'gallery-creative-activity',
      src: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/8bacp59p_794d3ea0-d2b5-4915-a894-ee4ae9981942.jpeg',
      alt: 'Estudiantes desarrollando actividades creativas'
    },
    {
      id: 'gallery-booth',
      src: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/p8hxffg2_3d3ba22f-9d00-463e-ab3b-1b9ade0718e2.JPG',
      alt: 'Equipo Rise & Shine en evento comunitario'
    },
    {
      id: 'gallery-costumes',
      src: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/hk3dhf3o_87724a32-3c72-47d4-8672-c8a0ac1c08c6.JPG',
      alt: 'Estudiantes en celebración cultural de Reyes Magos'
    },
    {
      id: 'gallery-inclusive-environment',
      src: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/s3tmnl3o_b8501fed-4808-4201-8d4a-19457bbbc213.jpeg',
      alt: 'Ambiente inclusivo y acogedor en Rise & Shine Learning Zone'
    }
  ];

  return (
    <div className="pt-20" data-testid="galeria-page">
      <section className="py-20 md:py-28 bg-gradient-to-br from-[#43b6b8] to-[#359a9c]">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white mb-6">
            Galería
          </h1>
          <p className="text-lg text-white/90 max-w-2xl mx-auto">
            Cada día es una experiencia única.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-28" data-testid="ambiente-section">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
          <div className="text-center mb-16">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#d3b163] mb-4 block">Nuestro Ambiente</span>
            <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-stone-900 mb-4">
              Un espacio diseñado para el aprendizaje
            </h2>
            <p className="text-base text-stone-700 max-w-3xl mx-auto">
              En Rise & Shine Learning Zone, creamos un ambiente acogedor y motivador donde los estudiantes se sienten seguros para explorar, preguntar y crecer. Cada rincón de nuestro centro está pensado para fomentar el aprendizaje efectivo y el desarrollo integral.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
              <h3 className="text-xl font-semibold text-stone-900 mb-3">Aulas Equipadas</h3>
              <p className="text-base text-stone-700 leading-relaxed">
                Espacios luminosos con tecnología educativa moderna y materiales didácticos actualizados.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
              <h3 className="text-xl font-semibold text-stone-900 mb-3">Grupos Pequeños</h3>
              <p className="text-base text-stone-700 leading-relaxed">
                Ambientes íntimos que permiten interacción personalizada entre educadores y estudiantes.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
              <h3 className="text-xl font-semibold text-stone-900 mb-3">Ambiente Cálido</h3>
              <p className="text-base text-stone-700 leading-relaxed">
                Un espacio familiar donde los niños se sienten valorados, escuchados y motivados.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 bg-[#F3F0EA]" data-testid="galeria-section">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
          <div className="text-center mb-16">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#d3b163] mb-4 block">Galería</span>
            <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-stone-900 mb-4">
              Capturando momentos especiales
            </h2>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
            {gallery.map((item) => (
              <div
                key={item.id}
                className="relative aspect-[4/3] rounded-2xl overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.06)] group cursor-pointer"
                data-testid={`gallery-image-${item.id}`}
              >
                <img
                  src={item.src}
                  alt={item.alt}
                  className="w-full h-full object-cover object-center group-hover:scale-[1.08] transition-transform duration-700 ease-out"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28" data-testid="actividades-section">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
          <div className="text-center mb-16">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#d3b163] mb-4 block">Actividades</span>
            <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-stone-900 mb-4">
              Más allá del salón de clases
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
              <h3 className="text-xl font-semibold text-stone-900 mb-4">Sesiones de Estudio Grupales</h3>
              <p className="text-base text-stone-700 leading-relaxed mb-4">
                Fomentamos el aprendizaje colaborativo donde los estudiantes trabajan juntos, comparten ideas y se apoyan mutuamente.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
              <h3 className="text-xl font-semibold text-stone-900 mb-4">Proyectos Especiales</h3>
              <p className="text-base text-stone-700 leading-relaxed mb-4">
                Desarrollamos proyectos creativos que conectan el aprendizaje con la vida real y estimulan la curiosidad.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
              <h3 className="text-xl font-semibold text-stone-900 mb-4">Celebraciones de Logros</h3>
              <p className="text-base text-stone-700 leading-relaxed mb-4">
                Reconocemos y celebramos el progreso de cada estudiante, fortaleciendo su autoestima y motivación.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
              <h3 className="text-xl font-semibold text-stone-900 mb-4">Conexión Familiar</h3>
              <p className="text-base text-stone-700 leading-relaxed mb-4">
                Mantenemos comunicación constante con las familias para asegurar el éxito continuo del estudiante.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#43b6b8]" data-testid="comunidad-section">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-white mb-6">
            Una comunidad donde todos pertenecen
          </h2>
          <p className="text-lg text-white/90 mb-8 max-w-3xl mx-auto">
            En Rise & Shine Learning Zone, cultivamos un ambiente de respeto, inclusión y apoyo mutuo donde cada estudiante puede alcanzar su máximo potencial.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <div className="bg-white/10 backdrop-blur px-6 py-3 rounded-full text-white">
              Respeto
            </div>
            <div className="bg-white/10 backdrop-blur px-6 py-3 rounded-full text-white">
              Inclusión
            </div>
            <div className="bg-white/10 backdrop-blur px-6 py-3 rounded-full text-white">
              Apoyo Mutuo
            </div>
            <div className="bg-white/10 backdrop-blur px-6 py-3 rounded-full text-white">
              Confianza
            </div>
            <div className="bg-white/10 backdrop-blur px-6 py-3 rounded-full text-white">
              Crecimiento
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
